module.exports = __webpack_public_path__ + "static/media/b_4.f8c6281a.jpg";